<!-- components/admin/ScoreCellAdmin.vue -->
<!-- แสดงคะแนน/ผลประเมินแต่ละครั้งในตาราง Admin -->
<!-- รองรับทั้งเกณฑ์เดิม (OLD: คะแนนตัวเลข) และเกณฑ์ใหม่ (NEW: ผ่าน/ไม่ผ่าน) -->
<template>
  <div class="score-cell-admin text-center">
    <!-- ===== เกณฑ์ใหม่ (NEW) ===== -->
    <template v-if="item.criteria_version === 'NEW'">
      <!-- ผลการประเมิน -->
      <div v-if="passStatus === 'pass'">
        <v-chip x-small color="success" dark>
          <v-icon x-small left>mdi-check-circle</v-icon> ผ่าน
        </v-chip>
      </div>
      <div v-else-if="passStatus === 'fail'">
        <v-chip x-small color="error" dark>
          <v-icon x-small left>mdi-close-circle</v-icon> ไม่ผ่าน
        </v-chip>
      </div>
      <div v-else-if="hasFile">
        <v-chip x-small outlined color="warning">
          <v-icon x-small left>mdi-clock-outline</v-icon> รอตรวจ
        </v-chip>
      </div>

      <!-- ปุ่มดูรายละเอียดกรรมการ -->
      <div v-if="passStatus" class="mt-1">
        <v-btn
          x-small
          text
          color="info"
          @click="$emit('view-committee', idValue)"
        >
          <v-icon x-small left>mdi-account-group</v-icon>
          รายกรรมการ
        </v-btn>
      </div>

      <!-- ปุ่มดูไฟล์ -->
      <div v-if="hasFile" class="mt-1">
        <v-btn
          icon
          x-small
          color="info"
          @click="$emit('view-file', fileValue)"
        >
          <v-icon x-small>mdi-printer</v-icon>
        </v-btn>
      </div>

      <!-- ปุ่มตรวจสอบ (สอศ.) -->
      <div v-if="passStatus" class="mt-1">
        <v-btn
          icon
          x-small
          :color="checkIconColor"
          @click="$emit('check', idValue)"
        >
          <v-icon x-small>{{ checkIcon }}</v-icon>
        </v-btn>
      </div>
    </template>

    <!-- ===== เกณฑ์เดิม (OLD) ===== -->
    <template v-else>
      <!-- คะแนนรวม -->
      <div v-if="scoreValue > 0">
        <span
          class="font-weight-bold"
          :class="scoreValue >= passThreshold ? 'success--text' : 'error--text'"
        >
          {{ scoreValue }}
        </span>
      </div>

      <!-- ปุ่มดูไฟล์ -->
      <div v-if="hasFile" class="mt-1">
        <v-btn
          icon
          x-small
          color="info"
          @click="$emit('view-file', fileValue)"
        >
          <v-icon x-small>mdi-printer</v-icon>
        </v-btn>
      </div>

      <!-- ปุ่มตรวจสอบ (สอศ.) -->
      <div v-if="scoreValue > 0" class="mt-1">
        <v-btn
          icon
          x-small
          :color="checkIconColor"
          @click="$emit('check', idValue)"
        >
          <v-icon x-small>{{ checkIcon }}</v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ScoreCellAdmin",
  props: {
    item: {
      type: Object,
      required: true
    },
    timeNo: {
      type: Number,
      required: true
    },
    passThresholdA: {
      type: Number,
      default: 24
    },
    passThresholdB: {
      type: Number,
      default: 36
    },
    passThreshold: {
      type: Number,
      default: 60
    }
  },
  computed: {
    prefix() {
      return "mt_time_" + this.timeNo;
    },
    scoreValue() {
      return parseFloat(this.item[this.prefix + "_score"]) || 0;
    },
    scoreA() {
      return parseFloat(this.item[this.prefix + "_score_a"]) || 0;
    },
    scoreB() {
      return parseFloat(this.item[this.prefix + "_score_b"]) || 0;
    },
    fileValue() {
      return this.item[this.prefix + "_file"] || "";
    },
    hasFile() {
      return String(this.fileValue).length > 4;
    },
    checkStatus() {
      return this.item[this.prefix + "_ck"] || "";
    },
    idValue() {
      return this.item[this.prefix + "_id"] || "";
    },
    passStatus() {
      return this.item[this.prefix + "_pass_status"] || "";
    },
    checkIcon() {
      if (this.checkStatus === "Pass") return "mdi-check-circle";
      if (this.checkStatus === "NotPass") return "mdi-close-box";
      return "mdi-magnify-close";
    },
    checkIconColor() {
      if (this.checkStatus === "Pass") return "success";
      if (this.checkStatus === "NotPass") return "red";
      return "grey";
    }
  }
};
</script>

<style scoped>
.score-cell-admin {
  min-width: 60px;
  padding: 2px 0;
}
</style>